import { useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col, Card, Form } from "react-bootstrap";
import { TextButton } from "Components/Button";
import { sendSmsFactor, submitMfaForBoth } from "../ResetPasswordAxiosFuncs";
import { PageInfo } from "Components/PageInformation/PageInformation";
import { PATHS } from "Utils/PagePaths";

const ResetPasswordVerifyMFA = ({
  mfaFactors
}) => {

  const { token } = useParams();
  const navigate = useNavigate();

  const [mfaToken, setMfaToken] = useState("");
  // error messages display on top 
  const [globalErrorList, setGlobalErrorList] = useState([]);
  const [disableSendCode, setDisableSendCode] = useState(false);
  const [showSendCodeMsg, setShowSendCodeMsg] = useState(false);
  const [disableMfaTokenField, setDisableMfaTokenField] = useState(true);
  const tokenInputRef = useRef();

  const handleSendCode = async () => {
    setDisableSendCode(true);
    const res = await sendSmsFactor(token, { userFactor: "SMS" });

    //console.log("handleSendCode()", res);

    if (res && res.data.status !== 1) {
      setGlobalErrorList(res.data.globalErrorMessageList);
      setDisableSendCode(false);
    } else {
      setTimeout(() => {
        setDisableSendCode(false);
      }, 30000);
      setShowSendCodeMsg(true);
      setDisableMfaTokenField(false);
      setTimeout(() => {
        tokenInputRef.current.focus();
      }, 500);
    }
  }

  // handle six digit mfa token field change
  const handleMfaChange = (e) => {

    let value = e.target.value;
    const regex = /^[0-9\b]+$/;

    //console.log("test mfa code", regex.test(value));

    if (value === '' || regex.test(value)) {
      setMfaToken(e.target.value);
    }
  }

  // api to verify the MFA token
  const verifyToken = async () => {
    // clear error
    setGlobalErrorList([]);
    setShowSendCodeMsg(false);

    const res = await submitMfaForBoth(token, mfaToken, 'SMS', true);
    //console.log("verifyToken", res);
    if (res && res.data.status !== 1) {
      setGlobalErrorList(res.data.globalErrorMessageList);
    } else {
      // go to reset password page
      navigate("/password/token/" + token + "/3", { state: { isForward: true } });
    }
  }

  const cancelMfa = () => {
    navigate(PATHS.public['Sign In']);
  }

  return (
    <Row className="mb-3">
      <Col xl={10} lg={11} md={11} sm={12}>
        <Card id="resetpwd-sms-mfa-verify" className="p-4">
          <Card.Body className="text-start">
            {/* <h1 id="mainContent" className="text-start mb-3 blue bold h1-form-title"> */}
            <h1 id="mainContent" className="text-start mb-3 blue fw-bold">
              Two-Factor Authentication
            </h1>
            <hr></hr>
            {showSendCodeMsg ?
              <>
                <PageInfo className="mb-3" type="info" message={"A code has been sent to your registered cell phone. Please enter that code in the field below. You may send a new code after 30 seconds if needed."}></PageInfo>
                <br />
              </>
              : null}
            {globalErrorList.map((item, index) =>
              <>
                <PageInfo key={"errors_" + index} type="error" message={item}></PageInfo>
                <br />
              </>
            )}
            <p>
              Please click the <span className="highlight">Send Code</span> button to receive your challenge code on your registered mobile device. Please enter the code in the text box and click the <span className="highlight">Verify</span> button.
            </p>
            <Form >
              <Row className="mb-4 align-items-center">
                <Col sm="5" className="pt-2 mfa-setting-label">
                  <div class="mfa-setting-step">
                    <span>1.</span>
                    <span>Click to send code to <span className="sms-last4-label">***-***-{mfaFactors.smsLast4}</span>.</span>
                  </div>
                </Col>
                <Col>
                  <TextButton
                    className="mt-1"
                    disabled={disableSendCode}
                    variant="normal"
                    onClick={handleSendCode}
                    content={"Send Code"}
                  >
                  </TextButton>
                </Col>
              </Row >
              <Form.Group as={Row} className="mb-3 align-items-center" controlId="mfaToken">
                <Form.Label column sm="5" className="mfa-setting-label">
                  2. Enter the six digit code.
                </Form.Label>
                <Col sm={3} xs={9}>
                  <Form.Control
                    ref={tokenInputRef}
                    disabled={disableMfaTokenField}
                    type="text"
                    maxlength={6}
                    value={mfaToken}
                    onChange={handleMfaChange}
                  />
                </Col>
              </Form.Group>
              <Row className="mb-3 pt-1 align-items-center mfa-setting-label">
                <Col sm="5" className="pt-2">3. Click Verify to confirm.</Col>
                <Col className="mt-1">
                  <TextButton
                    className="w-10"
                    variant="normal"
                    disabled={mfaToken.length !== 6}
                    onClick={verifyToken}
                    content={"Verify"}
                  >
                  </TextButton>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <TextButton
                    className="w-10"
                    variant="outline"
                    onClick={cancelMfa}
                    content={"Cancel"}
                  >
                  </TextButton>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default ResetPasswordVerifyMFA;